import { SUPPORT_EMAIL } from '../../lib/partnerAuth';
import styles from './SupportStrip.module.css';

export function SupportStrip() {
  return (
    <a href={`mailto:${SUPPORT_EMAIL}`} className={styles.strip}>
      <span className={styles.icon}>✉️</span>
      For payout or account questions, email us at{' '}
      <span className={styles.email}>{SUPPORT_EMAIL}</span>
      <span className={styles.minimum}> · Minimum payout is $10</span>
    </a>
  );
}
